import { useCanvaLogin, UseCanvaLoginConfig } from '@sparemin/auth';
import { useDispatch, useSelector } from 'react-redux';
import { pick } from 'underscore';
import { tokenSelector } from 'redux/modules/auth';
import {
  canvaAuthorizeSuccess,
  clearCanvaUserAction,
} from 'redux/modules/canva';
import { Dispatch } from 'redux/types';

export interface UseCanvaAuthenticatorConfig
  extends Pick<UseCanvaLoginConfig, 'force'> {
  onAuthSuccess?: () => void;
  onError?: (error: Error) => void;
}

export default function useCanvaAuthenticator({
  force,
  onAuthSuccess,
  onError,
}: UseCanvaAuthenticatorConfig) {
  const spareminToken = useSelector(tokenSelector);

  const dispatch = useDispatch<Dispatch>();

  return useCanvaLogin({
    force,
    spareminToken,
    onSuccess: async data => {
      dispatch(clearCanvaUserAction);

      if (data) {
        dispatch(
          canvaAuthorizeSuccess(
            pick(data.tokenInfo, 'accessToken', 'idToken', 'providerUserId'),
          ),
        );

        onAuthSuccess?.();
      }
    },
    onError,
  });
}
